module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/1@2x_728c835bfe6e68fc309cbcb2a012a3b7.png";